<template>
  <div :id="id" :class="className" :style="{height:height,width:width}" />
</template>
<script>
import echarts from 'echarts';
import resize from './mixins/resize';
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    chartData: {
      type: Object
    }
  },
  data() {
    return {
      chart: null,
      options: {
        xAxis: {
          type: 'category',
          axisLabel: {
            show: true,
            textStyle: {
              color: '#ffffff',
              fontSize: '8'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#ffffff'
            }
          },
          data: []
        },
        grid: {
          right: '0%',
          top: '15%',
          left: '15%'
        },
        yAxis: {
          type: 'value',
          name: '单位：万元',
          gridIndex: 0,
          nameTextStyle: {
            color: '#339FFB',
            fontSize: 10
          },
          axisLabel: {
            interval: 0,
            color: '#AEB7C0',
            fontSize: 12
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#ffffff'
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#1B2F44'
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#0A1D31'
            }
          }
        },
        legend: {
          icon: 'rect',
          show: true,
          orient: 'horizontal',
          x: 'center',
          y: 'bottom',
          data: [],
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: '#fff',
            fontSize: '12'
          },
          data: ['种植企业', '加工企业', '贩销企业', '服务企业']
        },
        title: {
          x: 'left',
          y: 'top'
        },
        series: []
      }
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        if (val) {
          this.setChartData();
        }
      }
    }
  },
  created() {},
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    setChartData() {
      var colors = ['#24CEBA', '#2B86D7', '#CEB32B', '#CE7B1D'];
      this.options.xAxis.data = this.chartData.timeList;
      this.options.series = [];
      this.$nextTick(() => {
        for (let i in this.chartData.productionList) {
          let color = '';
          switch (i) {
            case '种植企业':
              color = '#2BF9D7';
              break;
            case '加工企业':
              color = '#2B86D7';
              break;
            case '贩销企业':
              color = '#FFD824';
              break;
            case '服务企业':
              color = '#FF9212';
              break;
            default:
              break;
          }
          this.options.series.push({
            name: i,
            data: this.chartData.productionList[i].map(function(dataItem) {
              return dataItem.production;
            }),
            type: 'line',
            smooth: true,
            symbolSize: 8,
            itemStyle: {
              borderWidth: 3,
              shadowColor: 'rgba(0, 0, 0, .3)',
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
              normal: {
                // 折点颜色
                color: color,

                lineStyle: {
                  color: color
                  // 折线颜色
                }
              }
            }
          });
        }
        this.chart.setOption(this.options, true);
      });
    },
    initChart() {
      if (!this.chart) {
        this.chart = echarts.init(document.getElementById(this.id));
      }
      this.setChartData();
    }
  }
};
</script>